import { Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { getPageSize } from 'src/app/shared/utils/calsoft-validators';

@Component({
  selector: 'calsoft-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})
export class SummaryComponent implements OnInit {

  url = '';
  sanitizedUrl = '';

  displayedColumns = ['name', 'sku', 'manageStockSeperately', 'managePriceSeperately', 'manageImageSeperately', 'manageDescriptionSeperately', 'manageAdditionalInformationSeperately', 'manageNameSeperately'];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @Input() associatedProductListProductConfigured: any;
  dataSource: MatTableDataSource<Element>;
  spinner: boolean;
  constructor(private router: Router) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });


  }
  pageSizeValue: any;
  ngOnInit(): void {
    this.spinner = false;
    this.pageSizeValue = getPageSize(this.associatedProductListProductConfigured.length);
    this.dataSource = new MatTableDataSource(this.associatedProductListProductConfigured);
    this.dataSource.paginator = this.paginator;
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;

  }

  protected _onDestroy = new Subject<void>();

  sanitizeUrl(u: string): string {
    return (u || '').replace(/^\/+/, '').replace(/[?#&=]/g, '-').replace(/[^a-zA-Z0-9_-]+/g, '-').replace(/-+/g, '-').replace(/^[-]+|[-]+$/g, '').toLowerCase();
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
export interface Element {
  name: any;
  sku: any;
  manageStockSeperately: any;
  managePriceSeperately: any;
  manageImageSeperately: any;
  manageDescriptionSeperately: any;
  manageAdditionalInformationSeperately: any;
  manageNameSeperately: any;
}